import teamsApi from '../../api/team'

const state = {
  teams: [],
  ineligibleTeamMembers: [],
}

const getters = {
}

const actions = {
  getAll ({ commit }, userId) {
    teamsApi.getAll(userId, teams => {
      commit('setAllTeams', teams)
    })
  },

  getAtLocation ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      teamsApi.getAtLocation(locationId, teamMembers => {
        resolve(teamMembers)
      },
      error => {
        reject(error)
      })
    })
  },

  getIneligibleAtLocation ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      teamsApi.getIneligibleAtLocation(locationId, ineligibleTeamMembers => {
        resolve(ineligibleTeamMembers)
      },
      error => {
        reject(error)
      })
    })
  },

  updateTeamsAt ({ commit }, params) {
    return new Promise((resolve, reject) => {
      teamsApi.updateTeamsAt(params, teamMembers => {
        resolve(teamMembers)
      },
      error => {
        reject(error)
      })
    })
  },

 updateIneligibleTeamsAt ({ commit }, params) {
    return new Promise((resolve, reject) => {
      teamsApi.updateIneligibleTeamsAt(params, ineligibleTeamMembers => {
        resolve(ineligibleTeamMembers)
      },
      error => {
        reject(error)
      })
    })
  }, 

  addIneligibleTeamMembers({ commit }, params) {
    return new Promise((resolve, reject) => {
      teamsApi.addIneligibleTeamMembers(params, ineligibleTeamMembers => {
        commit('updateIneligibleTeamsAt', ineligibleTeamMembers)
        commit('setIneligibleTeams', ineligibleTeamMembers)
        resolve(ineligibleTeamMembers)
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  removeIneligibleTeamMembers({ commit }, params) {
    return new Promise((resolve, reject) => {
      teamsApi.removeIneligibleTeamMembers(params, ineligibleTeamMembers => {
        commit('updateIneligibleTeamsAt', ineligibleTeamMembers)
        commit('setIneligibleTeams', ineligibleTeamMembers)
        resolve(ineligibleTeamMembers)
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

}

const mutations = {
  setAllTeams (state, teams) {
    state.teams = teams
  },
  setIneligibleTeams (state, ineligibleTeamMembers) {
    state.ineligibleTeamMembers = ineligibleTeamMembers
  },
  updateIneligibleTeamsAt (state, ineligibleTeamMembers) {
    state.ineligibleTeamMembers = ineligibleTeamMembers
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
